import { render, staticRenderFns } from "./ListHotelFeeRule.vue?vue&type=template&id=37978166&"
import script from "./ListHotelFeeRule.vue?vue&type=script&lang=js&"
export * from "./ListHotelFeeRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports